"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = globalOffset;
function globalOffset(el) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  var _window = window,
      pageYOffset = _window.pageYOffset,
      pageXOffset = _window.pageXOffset;


  return {
    top: top + pageYOffset,
    left: left + pageXOffset
  };
}
module.exports = exports["default"];
